import React, { Component } from 'react';
import { withStyles, Card, CardHeader, CardContent, CardMedia, CardActions, IconButton, Collapse, Typography, TextField, Tooltip, Popover, Button} from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import clsx from 'clsx';
import { IPost } from '../../core/models/post';
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@material-ui/icons/Settings';
import AddEditPostCard from './new.post';
import { ADD_COMMENT, REMOVE_COMMENT, REMOVE_POST, REQUEST_COMMENTS, UPDATE_COMMENT, UPDATE_FEATUREDPOST, UPDATE_LIKE, UPDATE_LIKE_COUNT } from '../../core/handlers.actions';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import { IComment } from '../../core/models/comment';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import moment from 'moment';
import StarIcon from '@material-ui/icons/Star';
import { IWall } from '../../core/models/wall';

moment.updateLocale('en', {
    relativeTime: {
      future : 'in %s',
      past   : '%s ago',
      s  :  (number, withoutSuffix) =>  withoutSuffix ? 'now' : 'a few seconds',
      m  : '1m',
      mm : '%dm',
      h  : '1h',
      hh : '%dh',
      d  : '1d',
      dd : '%dd',
      M  : '1mth',
      MM : '%dmth',
      y  : '1y',
      yy : '%dy'
    }
  });

/**
 * layout 1 =  Title, image, description
 * layout 2 =  Image, title, description
 * layout 3 =  Title, description, Image
 */

interface Props {
    layoutType: number | any;
    classes: any;
    post: IPost | any;
    editPostId: string | null;
    editPostAction: (id:string | null) => void;
    closeAction: () => void;
    deletePost: (id:string) => void;
    likeDeslikePost: (data:any) => void;
    likeUpdater: (data:any) => void;
    addComment: (comment:any) => void;
    deleteComment: (commentId:string) => void;
    getComments: (postId:string) => void;
    commentUpdate: (comment:any) => void;
    user:any;
    comments:any;
    updateLayout:() => void;
    walls:any;
    wallId:string;
    postUpdateFeatured: (data:any) => void;
}

interface State { 
    expanded: boolean;
    toolsHidden:boolean;
    toolsOpen:boolean;
    addCommentMode:boolean;
    commentText:string | null;
    commentActionsOpen: boolean;
    commentActionsId: string | null;
    commentActionElement:any;
    commentToEdit:IComment | null;
    readyToEdit:boolean;
    isFeatured:boolean;
    wall: IWall | null;
    commentsLoaded: any;
    likes:number;
}

const styles = (theme: any) => ({
    root: {
        maxWidth: 345,
    },
    header: {
        '& .MuiCardHeader-content': {
            marginTop: '25px'
        }
    },
    media: {
        height: 0,
        paddingTop: '100%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    speedDial: {
        position: 'absolute' as any,
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            right: theme.spacing(-2),
            top: theme.spacing(-4)
        },
        '&>.MuiFab-primary': {width: '40px', height: '40px', backgroundColor: '#fff', color: '#490e6f'}
    },
    featuredButton: {
        position: 'absolute' as any,
        left: theme.spacing(-1),
        top: theme.spacing(-1)
    },
    buttonMoreActions: {
        fontSize: '12px'
    },
    featuredPost: {
        color: 'gold'
    },
    viewCommentButton: {
        fontSize: 12,
        color: '##490e6f'
    }

});


class WallPost extends Component<Props, State> {
    state: State = { 
        expanded: false,
        toolsHidden: false,
        toolsOpen: false,
        addCommentMode: false,
        commentText: null,
        commentActionsOpen: false,
        commentActionsId: null,
        commentActionElement: null,
        commentToEdit: null,
        readyToEdit:false,
        isFeatured:false,
        wall:null,
        commentsLoaded: [],
        likes: this.props.post.likes
    }

    constructor(props: Props) {
        super(props);
        this.renderCard = this.renderCard.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.handleToolsEvent = this.handleToolsEvent.bind(this);
        this.editPost = this.editPost.bind(this);
        this.likeHandler = this.likeHandler.bind(this);
        this.likeUpdater = this.likeUpdater.bind(this);
        this.commentTextHandler = this.commentTextHandler.bind(this);
        this.postComment = this.postComment.bind(this);
        this.editComment = this.editComment.bind(this);
        this.commentUpdate = this.commentUpdate.bind(this);
        this.makePostFeatured = this.makePostFeatured.bind(this);
        this.deletePost = this.deletePost.bind(this);
        this.renderHtmlContent = this.renderHtmlContent.bind(this);
        this.requestComments = this.requestComments.bind(this);
    }

    componentDidMount(){
        const {post, walls, wallId} = this.props;
        const wall = walls.find((wall:IWall) => wall._id === wallId) || false;  
        const isFeatured = wall.featuredPosts.findIndex((item:any) => item.id === post._id) === -1? false:true;                       
        this.setState({...this.state, isFeatured: isFeatured, wall:wall});        
    }

    public requestComments(id:string){
        const {commentsLoaded} = this.state;
        if(id === '') return;
        const {getComments, updateLayout} = this.props;
        getComments(id);
        updateLayout();
        commentsLoaded.push(id);
        this.setState({...this.state, commentsLoaded: commentsLoaded});
    }

    public renderHtmlContent(data:any){
        return {__html: data}
    }

    public editPost(id:any){
        const {editPostAction} = this.props;        
        editPostAction(id);
    }

    public handleExpandClick() {
        const {updateLayout} = this.props;
        this.setState({ ...this.state, expanded: !this.state.expanded });
        updateLayout();
    }

    public handleToolsEvent(){
        this.setState({...this.state, toolsOpen: !this.state.toolsOpen});
    }

    public likeHandler(post:any){
        const {likeDeslikePost} = this.props;
        const data = {postId: post._id, type:'post', userId: post.userId, likedBy: post.likedBy};
        likeDeslikePost(data);
    }

    public likeUpdater(number:number, id:string){
        const {likeUpdater} = this.props;        
        const data = {type: 'post', postId:id, count: number};            
        this.setState({...this.state, likes: number});   
        likeUpdater(data);
    }  

    public makePostFeatured(){
        const {postUpdateFeatured, wallId, post} = this.props;
        const {isFeatured, wall} = this.state;
        const type = isFeatured ? false: true;        
        postUpdateFeatured({wallId: wallId, postId: post._id, type: type, position: wall?.featuredPosts.length});       
    }

    public renderCard(layoutType: number) {
        const { classes, post} = this.props;
        const { expanded, toolsOpen, isFeatured} = this.state;
        const image = post.postImage;

        switch (layoutType) {
            case 1:
                return (
                    <div>                        
                        <CardHeader
                            action={(<div>
                                <SpeedDial
                                    ariaLabel="Tools"
                                    className={classes.speedDial}
                                    icon={<SettingsIcon />}
                                    onClose={this.handleToolsEvent}
                                    onOpen={this.handleToolsEvent}
                                    open={toolsOpen}
                                    direction={'left'}>
                                    <SpeedDialAction icon={<EditIcon />} tooltipTitle="Edit" onClick={() => this.editPost(post._id)}/>
                                    <SpeedDialAction icon={<DeleteIcon/>} tooltipTitle="Delete" onClick={this.deletePost}/>
                                </SpeedDial>
                                <Tooltip className={classes.featuredButton} title="Make it featured"><IconButton onClick={this.makePostFeatured}><StarIcon className={(isFeatured)? classes.featuredPost : ''}/></IconButton></Tooltip>                                                     
                            </div>)}
                            title={post.title}
                            subheader={moment(post.createdAt).format('LLL')} className={classes.header}/>
                        {(image) ? <CardMedia className={classes.media} image={image} title="post image" /> : null}                       
                        
                        {post.isTruncated ? (
                           <div>
                               {(!expanded)?(
                                   <CardContent>
                                   <Typography variant="body2" color="textSecondary" component="p" className="truncatedText" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                               </CardContent>
                               ): (<Collapse in={expanded} timeout="auto" unmountOnExit>
                               <CardContent>
                                   <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                               </CardContent>
                           </Collapse>)}       
                           </div>                            
                        ) : (<CardContent>
                            <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                        </CardContent>)}
                    </div>
                );
            case 2:
                return (
                    <div>
                        {(image) ? <CardMedia className={classes.media} image={image} title="post image" /> : null}
                        <CardHeader
                            action={(<div>
                                <SpeedDial
                                ariaLabel="Tools"
                                className={classes.speedDial}
                                icon={<SettingsIcon />}
                                onClose={this.handleToolsEvent}
                                onOpen={this.handleToolsEvent}
                                open={toolsOpen}
                                direction={'left'}>
                                    <SpeedDialAction icon={<EditIcon />} tooltipTitle="Edit" onClick={() => this.editPost(post._id)}/>
                                    <SpeedDialAction icon={<DeleteIcon/>} tooltipTitle="Delete" onClick={this.deletePost}/>
                            </SpeedDial>
                                <Tooltip className={classes.featuredButton} title="Make it featured"><IconButton onClick={this.makePostFeatured}><StarIcon className={(isFeatured)? classes.featuredPost : ''}/></IconButton></Tooltip>       
                            </div>)}
                            title={post.title}
                            subheader={moment(post.createdAt).format('LLL')} />
                        {post.isTruncated ? (
                           <div>
                               {(!expanded)?(
                                   <CardContent>
                                   <Typography variant="body2" color="textSecondary" component="p" className="truncatedText" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                               </CardContent>
                               ): (<Collapse in={expanded} timeout="auto" unmountOnExit>
                               <CardContent>
                                   <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                               </CardContent>
                           </Collapse>)}       
                           </div>                            
                        ) : (<CardContent>
                            <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                        </CardContent>)}
                    </div>
                );
            default:
                return (
                    <div>
                        <CardHeader
                            action={(<div>
                                    <SpeedDial
                                ariaLabel="Tools"
                                className={classes.speedDial}
                                icon={<SettingsIcon />}
                                onClose={this.handleToolsEvent}
                                onOpen={this.handleToolsEvent}
                                open={toolsOpen}
                                direction={'left'}>
                                    <SpeedDialAction icon={<EditIcon />} tooltipTitle="Edit" onClick={() => this.editPost(post._id)}/>
                                    <SpeedDialAction icon={<DeleteIcon/>} tooltipTitle="Delete" onClick={this.deletePost}/>
                            </SpeedDial>
                            <Tooltip className={classes.featuredButton} title="Make it featured"><IconButton onClick={this.makePostFeatured}><StarIcon className={(isFeatured)? classes.featuredPost : ''}/></IconButton></Tooltip>   
                            </div>)}
                            title={post.title}
                            subheader={moment(post.createdAt).format('LLL')} />
                       {post.isTruncated ? (
                           <div>
                               {(!expanded)?(
                                   <CardContent>
                                   <Typography variant="body2" color="textSecondary" component="p" className="truncatedText" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                               </CardContent>
                               ): (<Collapse in={expanded} timeout="auto" unmountOnExit>
                               <CardContent>
                                   <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                               </CardContent>
                           </Collapse>)}       
                           </div>                            
                        ) : (<CardContent>
                            <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                        </CardContent>)}
                        {(image) ? <CardMedia className={classes.media} image={image} title="post image" /> : null}
                    </div>
                );
        }
    }

    public commentTextHandler(e:any){
        const {name, value} = e.target;
        this.setState({...this.state, [name]: value});
    }  

    public postComment(postId:string){
        const{addComment, user} = this.props;
        const {commentText} = this.state;
        const data = {userId: user.id, postId:postId, isChildComment:false, comment: commentText};
        addComment(data);
        this.setState({...this.state, addCommentMode: !this.state.addCommentMode, commentText:null});
    }

    public commentUpdate(e:React.MouseEvent<HTMLButtonElement>){
        const {commentUpdate} = this.props;
        const {commentToEdit, commentText} = this.state;
        (commentToEdit as any).comment = commentText;    
        commentUpdate(commentToEdit);   
        this.setState({...this.state, commentActionsOpen: false, commentActionsId:null, commentText:null}); 
    }

    public editComment(){
        const {commentActionsId} = this.state; 
        const {comments} = this.props;
        const result:IComment = comments.find((comment:IComment) => comment._id === commentActionsId);
        this.setState({...this.state, commentToEdit: result, readyToEdit:true, commentActionsOpen:false, commentActionElement:null});
    }

    public deletePost(){
        const {deletePost, postUpdateFeatured, wallId, post} = this.props;  
        const {isFeatured, wall} = this.state;
        const type = isFeatured ? false: true;        
        postUpdateFeatured({wallId: wallId, postId: post._id, type: type, position: wall?.featuredPosts.length});   
        deletePost(post._id || '');
    }

    public render() {
        const { layoutType, classes, post, editPostId, closeAction,  deleteComment, comments, updateLayout } = this.props;
        const { expanded, addCommentMode, commentText,commentActionsOpen, commentActionsId, commentActionElement, readyToEdit, commentsLoaded, likes } = this.state;
          
        if(editPostId && editPostId === post._id) return(<AddEditPostCard tags={post.tags} post={post} action={closeAction} edit={true} featuredTag={post.featuredTag} tagsRef={post.tagsRef}/>);
        return (
            <Card className={classes.root}>
                {this.renderCard(layoutType)}                              
                <CardActions disableSpacing>
                    <FavoriteIcon color={likes>0?'secondary': 'inherit'}/>                 
                    <IconButton aria-label="Less" disabled={likes < 1} onClick={() => this.likeUpdater(likes - 1, post._id || '')}>
                        <IndeterminateCheckBoxIcon />
                    </IconButton>
                    <Typography variant="body2" component="p" className="likes-count">{likes}</Typography>
                    <IconButton aria-label="More" onClick={() => this.likeUpdater(likes + 1, post._id || '')}>
                        <AddBoxIcon />
                    </IconButton>                    
                    {post.isTruncated ? (
                        <IconButton
                            className={clsx(classes.expand, { [classes.expandOpen]: expanded })}
                            onClick={this.handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="show more">
                            <ExpandMoreIcon />
                        </IconButton>
                    ) : null}
                </CardActions>
                {post.totalComments > 0  && !commentsLoaded.includes(post._id)?
                    <IconButton className={classes.viewCommentButton} onClick={() => this.requestComments(post._id || '')}>View Comments <AddBoxIcon /></IconButton>
                :null}
                {(post.totalComments > 0) ? (
                    <CardContent>
                        <Typography variant="body2" component="p" className="likes-count">{post.totalComments} {post.totalComments ===1 ? 'Comment': 'Comments'}</Typography>
                        {comments.map((comment:IComment, key:number) => comment.postId === post._id? (
                            <Typography key={key} variant="body2" component="div" className="comment-holder">
                                <AccountCircleOutlinedIcon/>                                 
                                {comment._id === commentActionsId && readyToEdit? (<div>
                                    <TextField
                                        name="commentText"
                                        id="text-field-controlled"
                                        defaultValue={comment.comment}
                                        onChange={this.commentTextHandler}
                                        fullWidth
                                        label="Comment..." 
                                        multiline
                                        autoFocus
                                        rowsMax={10}/>
                                <Button className={classes.buttonMoreActions} color="secondary" onClick={this.commentUpdate}>Update</Button>
                                <Button className={classes.buttonMoreActions} color="secondary" onClick={() => this.setState({...this.state, commentActionsOpen: false, commentActionsId:null, commentActionElement:null, readyToEdit:false})}>Cancel</Button>
                                </div>): 
                                <div>
                                    <span className="comment-time"><strong>Annonimous</strong>  {moment(comment.createdAt).fromNow()}</span>
                                    <Typography variant="body2" component="p" className="likes-count">{comment.comment}</Typography>
                                </div>
                                }
                                <Tooltip title="more actions"><IconButton onClick={(e: React.MouseEvent<HTMLButtonElement>) => this.setState({...this.state, commentActionsOpen: !commentActionsOpen, commentActionsId: comment._id || '', commentActionElement: e.currentTarget})}><MoreHorizOutlinedIcon/></IconButton></Tooltip>
                            </Typography>):null)}
                    </CardContent>
                ):null}  
                {!addCommentMode? (
                    <CardActions disableSpacing>
                    <IconButton aria-label="Comment" onClick={() => {this.setState({...this.state, addCommentMode: !addCommentMode}); updateLayout();}}>
                        <ModeCommentIcon /> 
                        <Typography variant="body2" component="p" className="likes-count">&nbsp;Add Comment...</Typography>
                    </IconButton>
                </CardActions>
                ):(
                    <div>
                        <CardContent>
                            <TextField
                                name="commentText"
                                id="text-field-controlled"
                                defaultValue={commentText}
                                onChange={this.commentTextHandler}
                                fullWidth
                                label="Comment..." 
                                multiline
                                autoFocus
                                rowsMax={10}/>
                        </CardContent>
                        <CardActions disableSpacing>
                            <IconButton aria-label="cancel" onClick={() => {this.setState({...this.state, addCommentMode: !addCommentMode}); updateLayout();}}>
                                <DeleteOutlineIcon /> 
                            </IconButton>
                            <IconButton aria-label="add comment" onClick={() => this.postComment(post._id || '')}>
                                <PublishOutlinedIcon /> 
                            </IconButton>
                        </CardActions>
                    </div>                    
                )}    
                <Popover
                    id={commentActionsId || ''}
                    open={commentActionsOpen}
                    onClose={() => this.setState({...this.state, commentActionsOpen: false, commentActionsId:null, commentActionElement:null})}
                    anchorEl={commentActionElement}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center'}}
                    transformOrigin={{ vertical: 'bottom', horizontal: 'center',}}>
                        <Tooltip title="edit comment">
                            <IconButton onClick={() => this.editComment()}>
                                <EditIcon/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="delete comment">
                            <IconButton onClick={() =>  {deleteComment(commentActionsId || ''); this.setState({...this.state, commentActionsOpen: false, commentActionsId:null, commentActionElement:null})}}>
                                <DeleteIcon/>
                            </IconButton> 
                        </Tooltip>
                </Popover>            
            </Card>
        );
    }
}
const mapProps = (app:any) => ({user: app.rootReducer.user, comments: app.rootReducer.comments, walls: app.rootReducer.walls});
const mapDispatch = (dispatch:Dispatch) => ({
    deletePost: (postId:string) => dispatch({type: REMOVE_POST, payload: postId}),
    likeDeslikePost: (data:any) => dispatch({type: UPDATE_LIKE, payload: data}),
    likeUpdater: (data:any) => dispatch({type: UPDATE_LIKE_COUNT, payload: data}),
    addComment: (comment:any) => dispatch({type:ADD_COMMENT, payload: comment}),
    deleteComment: (commentId:string) => dispatch({type: REMOVE_COMMENT, payload: commentId}),
    getComments: (postId:string) => dispatch({type: REQUEST_COMMENTS, payload: postId}),
    commentUpdate: (comment:any) => dispatch({type: UPDATE_COMMENT, payload:comment}),
    postUpdateFeatured: (data:any) => dispatch({type: UPDATE_FEATUREDPOST, payload: data})
});
export default connect(mapProps, mapDispatch)(withStyles(styles)(WallPost));